export default __webpack_public_path__ + "static/media/q25_step2.31bf1457.png";